import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.IN.enumeration<
    ents.core.common.fileManagement.Purpose,
    graphql.schema.FilePurpose
  >({
    [ents.core.common.fileManagement.Purpose.DmsUpload]:
      graphql.schema.FilePurpose.DmsUpload,
    [ents.core.common.fileManagement.Purpose.FileManagement]:
      graphql.schema.FilePurpose.FileManagement,
  }),
  graphql.transformers.OUT.enumeration<
    graphql.schema.FilePurpose,
    ents.core.common.fileManagement.Purpose
  >({
    [graphql.schema.FilePurpose.DmsUpload]:
      ents.core.common.fileManagement.Purpose.DmsUpload,
    [graphql.schema.FilePurpose.FileManagement]:
      ents.core.common.fileManagement.Purpose.FileManagement,
  }),
)
